import React from "react";

const inputClass =
  "w-full rounded-lg border border-slate-700 bg-slate-950 px-3 py-2 text-sm text-slate-100 outline-none transition focus:border-indigo-400";

export type QuestionFormState = {
  question: string;
  option1: string;
  option2: string;
  option3: string;
  option4: string;
  correct_option: string;
};

type Props = {
  form: QuestionFormState;
  onChange: (field: keyof QuestionFormState, value: string) => void;
};

export default function QuestionFormFields({ form, onChange }: Props) {
  return (
    <>
      <label className="space-y-2 md:col-span-2">
        <span className="text-sm text-slate-300">متن سوال</span>
        <textarea
          rows={3}
          value={form.question}
          onChange={(e) => onChange("question", e.target.value)}
          className={inputClass}
          placeholder="سوال را وارد کنید..."
        />
      </label>
      {(["option1", "option2", "option3", "option4"] as const).map((key, index) => (
        <label key={key} className="space-y-2">
          <span className="text-sm text-slate-300">گزینه {index + 1}</span>
          <input
            value={form[key]}
            onChange={(e) => onChange(key, e.target.value)}
            className={inputClass}
          />
        </label>
      ))}
      <label className="space-y-2 md:col-span-2">
        <span className="text-sm text-slate-300">پاسخ صحیح</span>
        <select
          className={inputClass}
          value={form.correct_option}
          onChange={(e) => onChange("correct_option", e.target.value)}
        >
          <option value="">انتخاب کنید</option>
          <option value="1">گزینه ۱</option>
          <option value="2">گزینه ۲</option>
          <option value="3">گزینه ۳</option>
          <option value="4">گزینه ۴</option>
        </select>
      </label>
    </>
  );
}

export function isQuestionFormValid(form: QuestionFormState) {
  return Boolean(
    form.question.trim() &&
      form.option1.trim() &&
      form.option2.trim() &&
      form.option3.trim() &&
      form.option4.trim() &&
      ["1", "2", "3", "4"].includes(form.correct_option)
  );
}

export function emptyQuestionForm(): QuestionFormState {
  return {
    question: "",
    option1: "",
    option2: "",
    option3: "",
    option4: "",
    correct_option: "",
  };
}
